<template>
  <div class="login-container">
    <div class="header">
      <!-- <img src="~@/assets/img/login-header-bg.png" alt="" /> -->
    </div>
    <div class="main">
      <div class="tabs">
        <template v-if="tabActiveValue === 'forget'">
          <div class="forget-return tab" style="width: 100%">
            <img
              class="img-icon"
              src="~@/assets/img/icon-back.png"
              @click="handleTabClick('login')"
            />
            <span @click="handleTabClick('login')">返回登录</span>
          </div>
        </template>
        <template v-else>
          <div
            class="tab"
            :class="{ active: tabActiveValue === 'login' ? true : false }"
            :style="
              tabActiveValue === 'login'
                ? {
                    clipPath: 'polygon(0 0, 85% 0, 100% 100%, 0% 100%)',
                    position: 'absolute',
                    left: '0px',
                  }
                : { position: 'absolute', left: '0px' }
            "
            @click="handleTabClick('login')"
          >
            <span>账号登录</span>
          </div>
          <div
            class="tab"
            :class="{ active: tabActiveValue === 'register' ? true : false }"
            :style="
              tabActiveValue === 'register'
                ? {
                    clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0% 100%)',
                    position: 'absolute',
                    right: '0px',
                  }
                : { position: 'absolute', right: '0px' }
            "
            @click="handleTabClick('register')"
          >
            <span>账号注册</span>
          </div>
        </template>
      </div>
      <div class="title">SylaOS-V6 移动缴费端</div>
      <!-- 方心科技移动缴费系统 -->
      <div class="form">
        <template v-if="tabActiveValue === 'login'">
          <login-form @handleTabClick="handleTabClick" />
        </template>
        <template v-if="tabActiveValue === 'register'">
          <register-form />
        </template>
        <template v-if="tabActiveValue === 'forget'">
          <forget-form />
        </template>
      </div>
    </div>
    <!-- @click="handleTabClick('register')" -->
    <div class="footer">
      <p>
        登录使用就表示同意用户协议<a href="javascript:;">条款</a>和<a
          href="javascript:;"
          >隐私</a
        >政策
      </p>
    </div>
  </div>
</template>

<script>
import LoginForm from "./cpns/login-form.vue";
import RegisterForm from "./cpns/register-form.vue";
import ForgetForm from "./cpns/forget-form.vue";

export default {
  name: "login",
  components: { LoginForm, RegisterForm, ForgetForm },
  data() {
    return {
      tabActiveValue: "login",
    };
  },
  mounted() {
    this.$globalFunction.handleContainerHeight(".login-container");
  },
  methods: {
    handleTabClick(tabName) {
      this.tabActiveValue = tabName;
    },
  },
};
</script>

<style lang="less">
@iconSize: 70px;
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  font-size: 14px;
  .header {
    height: 190px;
    background: url(~@/assets/img/login-header-bg.png) no-repeat;
    background-size: 100%;
    background-position: bottom 0px left 0px;
  }
  .main {
    .tabs {
      position: relative;
      margin-top: -15px;
      height: 32px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .tab {
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 55%;
        font-weight: bold;
        color: #fff;
        letter-spacing: 2px;
        background: linear-gradient(90deg, #64acff, #357af0);
      }
      .active {
        height: calc(100% + 8px);
        margin-top: -6px;
        color: black;
        background: white;
        span {
          margin-top: 4px;
        }
        z-index: 1;
      }
      .forget-return {
        display: flex;
        justify-content: start;
        padding: 3px 5px;
        width: 100%;
        .img-icon {
          width: 20px;
          height: 20px;
          margin-right: 3px;
        }
      }
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 70px;
      font-size: 18px;
      font-style: italic;
      font-weight: bold;
      letter-spacing: 3px;
      background-image: linear-gradient(to right, #0096e9, #116df4);
      background-clip: text;
      color: transparent;
    }
  }
  .form {
    padding: 0 50px;
    .item {
      position: relative;
      margin-bottom: 20px;
      input {
        width: calc(100% - 39px);
        height: 30px;
        border: 1px solid #8aaee6;
        // #3066ba
        border-radius: 3px;
        padding-left: 35px;
      }
      input::placeholder {
        color: #7890b9;
      }
      .icon {
        position: absolute;
        top: calc(20px - 13px);
        left: 10px;
        height: 20px;
      }
    }
    .item.code {
      display: flex;
      .send-code {
        margin-left: 10px;
        span {
          display: block;
          width: 80px;
          height: 34px;
          color: #fff;
          border-radius: 5px;
          text-align: center;
          line-height: 34px;
          font-size: 12px;
          background: linear-gradient(to left, #64acff, #357af0);
        }
      }
    }
    .control {
      display: flex;
      justify-content: space-between;
    }
    .submit {
      margin-top: 50px;
      button {
        width: 100%;
        height: 40px;
        color: #fff;
        background-color: #336dd0;
        border: 0px;
        border-radius: 5px;
        box-shadow: 0 0 10px 0px #adb5bd;
      }
    }
  }
  .footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
}
// .login {
//   width: 100vw;
//   height: 100vh;
//   overflow-x: hidden;
//   background: url(~@/assets/img/top_bg.png) top left no-repeat;
//   background-size: 100%;
//   .head {
//     width: 100%;
//     height: 20%;
//     .img {
//       width: @iconSize;
//       height: @iconSize;
//       background: #ffffff;
//       border-radius: 50%;
//       margin: 0 auto;
//       margin-top: 10%;
//       text-align: center;
//       overflow: hidden;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//     img {
//       width: @iconSize - 20px;
//     }
//     p {
//       text-align: center;
//       color: #ffffff;
//       font-size: 16px;
//     }
//   }
//   .register {
//     margin: 60px 20px 0 20px;
//     font-size: 14px;
//     text-align: right;
//     color: #888;
//     font {
//       color: #1f6ecf;
//     }
//   }
//   /*登陆表单*/
//   form {
//     width: 100%;
//     height: auto;
//     overflow: hidden;
//     padding: 20px 20px 20px 20px;
//     .item {
//       display: flex;
//       align-items: center;
//       width: calc(100% - 40px);
//       height: 40px;
//       margin-bottom: 30px;
//       color: #333333;
//       input {
//         width: 100%;
//         height: 100%;
//         display: inline-block;
//         border: 1px solid #ebebeb;
//         border-radius: 20px;
//         box-shadow: 0px 0px 10px rgba(200, 200, 200, 0.1);
//         padding-left: 35px;
//         outline: none;
//         &.name {
//           background: url(~@/assets/img/icon-phone.png) left 15px center
//             no-repeat;
//           background-size: 12px auto;
//         }
//         &.password {
//           background: url(~@/assets/img/icon-lock.png) left 15px center
//             no-repeat;
//           background-size: 12px auto;
//         }
//       }
//     }
//     .forget {
//       display: flex;
//       width: calc(100% - 40px);
//       align-items: center;
//       justify-content: space-between;
//       margin-bottom: 20px;
//       .remember {
//         font-size: 13px;
//       }
//       .for {
//         font-size: 13px;
//         color: #1f6ecf;
//       }
//     }
//     .submit {
//       width: calc(100% - 40px);
//       button {
//         border: none;
//         width: 100%;
//         height: 40px;
//         line-height: 40px;
//         text-align: center;
//         font-size: 18px;
//         color: #ffffff;
//         border-radius: 20px;
//         outline: none;
//         box-shadow: 0 5px 5px rgba(31, 110, 207, 0.2);
//         display: inline-block;
//         width: 100%;
//         background: #1f6ecf;
//       }
//     }
//   }
//   /*尾部*/
//   .footer {
//     text-align: center;
//     padding-top: 20px;
//     p {
//       font-size: 14px;
//       color: #666666;
//       text-align: center;
//       padding: 10px 0 5px 0;
//       letter-spacing: 1px;
//       a {
//         color: #078dda;
//       }
//     }
//   }
// }
</style>
